import React, { useState, useEffect } from "react";
import { Box, Heading, Text, Button } from "grommet";
import { useNavigate } from "react-router-dom";

const RateLimitPage = () => {
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const retryAt = parseInt(params.get("retryAt"), 10) || null;

  const getSecondsLeft = () =>
    retryAt ? Math.max(0, Math.ceil((retryAt - Date.now()) / 1000)) : null;

  const [secondsLeft, setSecondsLeft] = useState(getSecondsLeft);

  useEffect(() => {
    if (!retryAt) return;
    const interval = setInterval(() => {
      const left = getSecondsLeft();
      setSecondsLeft(left);
      if (left <= 0) clearInterval(interval);
    }, 1000);
    return () => clearInterval(interval);
  }, [retryAt]);

  const formatTime = (secs) => {
    const m = Math.floor(secs / 60);
    const s = secs % 60;
    return m > 0 ? `${m}m ${s}s` : `${s}s`;
  };

  return (
    <Box align="center" justify="center" pad="large" height="100vh">
      <Heading level="1">Error</Heading>
      <Heading level="3" margin={{ top: "small", bottom: "small" }}>
        Too Many Requests
      </Heading>
      <Text size="large" textAlign="center" margin={{ bottom: "small" }}>
        Rate limit exceeded. Please try again later.
      </Text>
      {secondsLeft !== null && secondsLeft > 0 && (
        <Text
          size="medium"
          textAlign="center"
          margin={{ bottom: "medium" }}
          color="status-warning"
        >
          Please try again in <strong>{formatTime(secondsLeft)}</strong>.
        </Text>
      )}
      {secondsLeft === 0 && (
        <Text
          size="medium"
          textAlign="center"
          margin={{ bottom: "medium" }}
          color="status-ok"
        >
          You can try again now.
        </Text>
      )}
      {secondsLeft === null && (
        <Text size="medium" textAlign="center" margin={{ bottom: "medium" }}>
          Please wait a moment and try again.
        </Text>
      )}
      <Button
        label={secondsLeft === 0 ? "Try Again" : "Go Back"}
        onClick={() => navigate(-1)}
        primary
        disabled={secondsLeft !== null && secondsLeft > 0}
      />
    </Box>
  );
};

export default RateLimitPage;
